export default "__VITE_ASSET__BeGMWWVE__"